import { render, staticRenderFns } from "./order_shipment_details.vue?vue&type=template&id=68cc0c1b&"
import script from "./order_shipment_details.vue?vue&type=script&lang=js&"
export * from "./order_shipment_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports